export default __webpack_public_path__ + "navigation-examples-building-extrusion-thumbnail-480-ea01792af90796cd387007d9d0297b42.png";